// Centralized application data and content
// Update this file to change content across the entire application

export const APP_CONFIG = {
  // Brand Information
  brand: {
    name: "WeddingzVenue",
    logoIcon: "WV",
    tagline: "India's largest wedding planning platform",
    description: "Plan your dream wedding with the best vendors and venues.",
  },
  STEPS: [
    { id: 1, title: "Business details", short: "Details" },
    { id: 2, title: "Services & Features", short: "Services & Features" },
    { id: 3, title: "Description & amenities", short: "Amenities" },
    { id: 4, title: "Photos", short: "Photos" },
  ],
  BUSINESS_TYPE_OPTIONS: [
    { value: "vendor", label: "vendor" },
    { value: "venue", label: "venue" },
  ],
  VENDOR_TYPE_OPTIONS: [
    { value: "photographer", label: "Photographer" },
    { value: "makeup-artist", label: "Makeup Artist" },
    { value: "mehendi-artist", label: "Mehendi Artist" },
    { value: "decorator", label: "Decorator" },
    { value: "caterer", label: "Caterer" },
    { value: "band-baja", label: "Band Baja" },
  ],
  VENUE_TYPE_OPTIONS: [
    { value: "banquet", label: "Banquet" },
    { value: "lawn", label: "Lawn" },
    { value: "hotel", label: "Hotel" },
    { value: "resort", label: "Resort" },
  ],

  /** Vendor-type-specific offering tags for step 3 (label: Offerings). Key = vendor_type value. */
  VENDOR_OFFERING_TAGS: {
    photographer: [
      "Destination Photography",
      "Wedding Photography",
      "Pre-wedding Shoot",
      "Candid Photography",
      "Cinematography",
      "Drone Shots",
      "Album Design",
      "Engagement Shoot",
    ],
    "makeup-artist": [
      "Bridal Makeup",
      "Engagement Makeup",
      "Reception Makeup",
      "Trial Makeup",
      "Hair Styling",
      "Saree Draping",
      "Mehendi Makeup",
    ],
    "mehendi-artist": [
      "Bridal Mehendi",
      "Family Mehendi",
      "Designer Mehendi",
      "Arabic Mehendi",
      "Rajasthani Mehendi",
      "Glitter Mehendi",
    ],
    decorator: [
      "Mandap Decoration",
      "Stage Decoration",
      "Entrance Decoration",
      "Floral Decoration",
      "Theme Decoration",
      "Lighting",
      "Backdrop",
    ],
    caterer: [
      "North Indian",
      "South Indian",
      "Continental",
      "Chinese",
      "Live Counters",
      "Desserts",
      "Beverages",
      "Wedding Feast",
    ],
    "band-baja": [
      "Wedding Band",
      "DJ",
      "Sound System",
      "Dhol",
      "Shehnai",
      "Live Music",
    ],
  },

  // Cities List (used across multiple components)
  cities: ["Delhi", "Noida", "Ghaziabad", "Gurugram", "Faridabad"],

  // Header Navigation
  header: {
    logoText: "WeddingzVenue",
    logoIcon: "",
    citySearchPlaceholder: "Select city...",
    listBusinessText: "List Your Business",
    callButtonText: "Enquire Now",
    navItems: [
      { label: "Venues", hasDropdown: true },
      { label: "Vendors", hasDropdown: true },
      { label: "Blog", path: "/blog" },
      { label: "Real Weddings", path: "/real-weddings" },
      { label: "Photos", path: "/photos" },
      { label: "Testimonials", path: "/testimonials" },
      { label: "Why WeddingzVenue", path: "/why-weddingzvenue" },
    ],
    venueTypes: [
      { label: "Hotels", path: "#hotels" },
      { label: "Banquet Halls", path: "#banquet-halls" },
      { label: "Resorts", path: "#resorts" },

      { label: "Farmhouses", path: "#farmhouses" },
      { label: "Lawns", path: "#lawns" },
      { label: "Beach Venues", path: "#beach-venues" },
      { label: "Destination Weddings", path: "#destination-weddings" },
    ],
    vendorTypes: [
      { label: "Photographers", path: "#photographers", id: "photographer" },
      { label: "Makeup Artists", path: "#makeup-artists", id: "makeup-artist" },
      {
        label: "Mehendi Artists",
        path: "#mehendi-artists",
        id: "mehendi-artist",
      },
      { label: "Caterers", path: "#caterers", id: "caterer" },
      { label: "Decorators", path: "#decorators", id: "decorator" },
      { label: "Band Baja", path: "#band-baja", id: "band-baja" },
    ],
  },

  // Hero Section
  hero: {
    badge: "✨ Trusted by 50,000+ couples · Free to browse & enquire",
    title: ["Find Your Dream Wedding Venue"],

    subtitle:
      "Compare Verified Banquet Halls, Hotels & Wedding Vendors Across India. Get the Best Prices with Free Booking Assistance.",
    citySelectPlaceholder: "Select City",
    searchButtonText: "Search",
    taglines: [
      "Verified venues & vendors",
      "Real reviews from couples",
      "Browse by city & budget",
    ],
  },

  // Cities Section
  citiesSection: {
    title: "Popular wedding destinations we cover",
    subtitle:
      "Delhi, Mumbai, Bangalore, Jaipur, Hyderabad, Chennai, Kolkata, Pune, Udaipur, Goa, Chandigarh, Lucknow, Ahmedabad, Surat, Kochi, Noida, Ghaziabad, and more — find banquet halls and vendors in your city.",
    banquetHallsCta: "Banquet Halls",
    vendorsCta: "Vendors",
    // City images mapping - using high-quality free images from Pexels/Unsplash
    cityImages: {
      "Delhi NCR":
        "https://images.pexels.com/photos/1078850/pexels-photo-1078850.jpeg?auto=compress&cs=tinysrgb&w=800",
      Mumbai:
        "https://images.pexels.com/photos/2901209/pexels-photo-2901209.jpeg?auto=compress&cs=tinysrgb&w=800",
      Bangalore:
        "https://images.pexels.com/photos/2901209/pexels-photo-2901209.jpeg?auto=compress&cs=tinysrgb&w=800",
      Chennai:
        "https://images.pexels.com/photos/1078850/pexels-photo-1078850.jpeg?auto=compress&cs=tinysrgb&w=800",
      Hyderabad:
        "https://images.pexels.com/photos/2901209/pexels-photo-2901209.jpeg?auto=compress&cs=tinysrgb&w=800",
      Pune: "https://images.pexels.com/photos/1078850/pexels-photo-1078850.jpeg?auto=compress&cs=tinysrgb&w=800",
      Kolkata:
        "https://images.pexels.com/photos/2901209/pexels-photo-2901209.jpeg?auto=compress&cs=tinysrgb&w=800",
      Jaipur:
        "https://images.pexels.com/photos/1078850/pexels-photo-1078850.jpeg?auto=compress&cs=tinysrgb&w=800",
      Ahmedabad:
        "https://images.pexels.com/photos/2901209/pexels-photo-2901209.jpeg?auto=compress&cs=tinysrgb&w=800",
      Surat:
        "https://images.pexels.com/photos/1078850/pexels-photo-1078850.jpeg?auto=compress&cs=tinysrgb&w=800",
      Lucknow:
        "https://images.pexels.com/photos/2901209/pexels-photo-2901209.jpeg?auto=compress&cs=tinysrgb&w=800",
      Kanpur:
        "https://images.pexels.com/photos/1078850/pexels-photo-1078850.jpeg?auto=compress&cs=tinysrgb&w=800",
      Nagpur:
        "https://images.pexels.com/photos/2901209/pexels-photo-2901209.jpeg?auto=compress&cs=tinysrgb&w=800",
      Indore:
        "https://images.pexels.com/photos/1078850/pexels-photo-1078850.jpeg?auto=compress&cs=tinysrgb&w=800",
      Thane:
        "https://images.pexels.com/photos/2901209/pexels-photo-2901209.jpeg?auto=compress&cs=tinysrgb&w=800",
      Bhopal:
        "https://images.pexels.com/photos/1078850/pexels-photo-1078850.jpeg?auto=compress&cs=tinysrgb&w=800",
      Visakhapatnam:
        "https://images.pexels.com/photos/2901209/pexels-photo-2901209.jpeg?auto=compress&cs=tinysrgb&w=800",
      Patna:
        "https://images.pexels.com/photos/1078850/pexels-photo-1078850.jpeg?auto=compress&cs=tinysrgb&w=800",
      Vadodara:
        "https://images.pexels.com/photos/2901209/pexels-photo-2901209.jpeg?auto=compress&cs=tinysrgb&w=800",
      Ghaziabad:
        "https://images.pexels.com/photos/1078850/pexels-photo-1078850.jpeg?auto=compress&cs=tinysrgb&w=800",
    },
  },

  // Vendor Categories (for Vendors Page)
  vendorCategories: [
    { id: "photographer", name: "Photographer", icon: "📷" },
    { id: "videographer", name: "Videographer", icon: "🎥" },
    { id: "makeup-artist", name: "Makeup Artist", icon: "💄" },
    { id: "caterer", name: "Caterer", icon: "🍽️" },
    { id: "decorator", name: "Decorator", icon: "🎨" },
    { id: "dj-sound", name: "DJ & Sound", icon: "🎵" },
    { id: "band-baja", name: "Band Baja", icon: "🎵" },
    { id: "bridal-wear", name: "Bridal Wear", icon: "👗" },
    { id: "groom-wear", name: "Groom Wear", icon: "👔" },
    { id: "jewelry", name: "Jewelry", icon: "💍" },
    { id: "mehendi-artist", name: "Mehendi Artist", icon: "🖌️" },
    {
      id: "anchor-event-coordinator",
      name: "Anchor & Event coordinator",
      icon: "🎤",
    },
    {
      id: "photographer-videographer",
      name: "Photographer  & videographer",
      icon: "📸",
    },
    { id: "band-baja-baggi", name: "Band Baja & Baggi", icon: "🥁" },
    { id: "dhol-bhangra", name: "Dhol & Bhangra", icon: "🕺" },
    { id: "event-planeer", name: "Event Planeer", icon: "📋" },
    {
      id: "fog-event-mirror-entry",
      name: "Fog Event & Mirror Entry",
      icon: "✨",
    },
    { id: "tatto-artist", name: "Tatto Artist", icon: "🖋️" },
    { id: "messkot", name: "Messkot", icon: "🎭" },
    { id: "nail-artist", name: "Nail Artist", icon: "💅" },
    { id: "tour-travels", name: "Tour & Travels", icon: "🚌" },
    { id: "welcome-flower-girls", name: "Welcome Flower girls", icon: "🌸" },
    { id: "bar-girls", name: "Bar girls", icon: "🍸" },
    { id: "dancer", name: "Dancer", icon: "💃" },
    { id: "waiters", name: "Waiters", icon: "🧑‍🍳" },
    {
      id: "vallet-parking-drivers",
      name: "Vallet parking Drivers",
      icon: "🚗",
    },
    { id: "ballon-decorater", name: "Ballon Decorater", icon: "🎈" },
    { id: "return-gift-vendor", name: "Return Gift Vendor", icon: "🎁" },
    { id: "pandit-ji", name: "Pandit Ji", icon: "🕉️" },
    {
      id: "private-party-orgenizers",
      name: "Private party Orgenizers",
      icon: "🎉",
    },
  ],

  // Pages
  pages: {
    venues: {
      title: "All Wedding Venues",
      titleWithCity: (type, city) =>
        `${type.toLowerCase().replace(/^\w/, (c) => c.toUpperCase())}s in ${city}`,
      subtitle:
        "Banquet halls, farmhouses, hotels, rooftops, and destination venues across India — filter by capacity, location, and budget.",
      subtitleWithCity: (type, city) =>
        `Discover the best Wedding ${type
          .toLowerCase()
          .replace(/^\w/, (c) => c.toUpperCase())}s in ${city}`,
      noResults: (city) =>
        `No banquet halls found for ${city}. Please try another city.`,
    },
    vendors: {
      title: "Wedding Vendors",
      titleWithCity: (city) => `All Vendors in ${city}`,
      subtitle:
        "Photographers, decorators, caterers, makeup artists, mehendi artists, DJs, and more — verified listings, manually reviewed before they go live.",
      subtitleWithCity: (city) =>
        `Top wedding vendors in ${city} — compare portfolios, packages, and reviews, then send enquiries in one place.`,
      backToCategories: "← Back to Categories",
      noResults: (category, city) => {
        const cityText = city ? ` in ${city}` : "";
        return `No ${category?.toLowerCase()} vendors found${cityText}. Please try another category or city.`;
      },
    },
    blog: {
      title: "Wedding planning tips, ideas & inspiration",
      subtitle:
        "Expert planning tips, décor ideas, bridal fashion, catering inspiration, and budget guides — for Delhi, Noida, Ghaziabad, and beyond.",
    },
    realWeddings: {
      title: "Real Indian wedding stories & inspiration",
      subtitle:
        "Venues in Delhi, Noida, Ghaziabad, and beyond — décor, outfits, and moments from couples who planned with WeddingZVenue.",
    },
    photos: {
      title: "Wedding photos & ideas gallery",
      subtitle:
        "Indian wedding décor, bridal looks, and venue setups — get inspired for your perfect day.",
    },
    testimonials: {
      title: "Customer reviews & testimonials",
      subtitle:
        "Real couples and vendors who booked through WeddingZVenue — Delhi, Noida, Ghaziabad, and across India.",
    },
    whyWeddingzVenue: {
      title: "Why choose WeddingZVenue",
      subtitle:
        "Verified vendors and venues, real reviews, and expert support — free for couples across Delhi, Noida, Ghaziabad, and India.",
    },
  },

  // Login Modal
  loginModal: {
    title: "Log in to your Account",
    subtitle: "Welcome back! Select method to log in:",
    emailPlaceholder: "Enter your email address",
    orText: "or",
    continueWithEmail: "or continue with email",
    googleSignInText: "Sign in with Google",
    newUserText: "New User",
    newBusinessText: "New Business",
    businessLoginText: "Log in as business",
    adminLoginText: "Admin Login",
    noAccountText: "Don't have an account?",
    createAccountText: "Create an account",
    promoHeadline: "Find Your Dream Wedding Venue",
    promoSubtitle: "Connect with the best venues and vendors for your big day.",
  },

  // Business Login Modal (same form, different heading/color)
  businessLoginModal: {
    title: "Log in to your Account",
    subtitle: "Welcome back! Select method to log in:",
    emailPlaceholder: "Enter your email address",
    orText: "or",
    continueWithEmail: "or continue with email",
    googleSignInText: "Sign in with Google",
    newUserText: "New User",
    newBusinessText: "New Business",
    adminLoginText: "Admin Login",
    noAccountText: "Don't have an account?",
    createAccountText: "Create an account",
    promoHeadline: "List your venue or services.",
    promoSubtitle: "Reach thousands of couples planning their perfect wedding.",
  },

  // Create Account page (right panel promo – matches login screenshot)
  registerPage: {
    title: "Create an account",
    subtitle: "Join WeddingzVenue to plan your perfect wedding.",
    promoHeadline: "Find Your Dream Wedding Venue.",
    promoSubtitle: "Connect with the best venues and vendors for your big day.",
    fromBusinessTitle: "Create your account",
    fromBusinessSubtitle:
      "One account for planning and listing—use your details below.",
    fromBusinessPromoHeadline: "One platform, two ways to grow.",
    fromBusinessPromoSubtitle:
      "List your business and plan your own wedding with the same account.",
  },

  // Contact Us Banner (above footer)
  contactBanner: {
    headline: "Let's make your dream wedding a reality",
    subline: "Have questions? Our team is here to help you plan every detail.",
    ctaText: "Get in touch",
    ctaAriaLabel: "Open enquiry form",
    orText: "or reach us directly",
    phoneLabel: "Call us",
    emailLabel: "Email us",
  },

  // Footer
  footer: {
    description:
      "India's largest wedding planning platform. Plan your dream wedding with the best vendors and venues.",
    quickLinks: [
      { label: "Venues", path: "/venues/venue" },
      { label: "Vendors", path: "/vendors" },
      { label: "Real Weddings", path: "/real-weddings" },
      { label: "Blog", path: "/blog" },
      { label: "Photos", path: "/photos" },
    ],
    businessLinks: [
      { label: "List Your Business", path: "/list-your-business" },
      { label: "Advertise With Us", path: "/advertise" },
      { label: "Partners", path: "/partners" },
      { label: "Vendor Login", path: "/login" },
    ],
    supportLinks: [
      { label: "Help Center", path: "/help" },
      { label: "Contact Us", path: "/contact" },
      { label: "FAQ", path: "/faq" },
      { label: "Privacy Policy", path: "/privacy-policy" },
      { label: "Terms & Conditions", path: "/terms" },
    ],
    contact: {
      phone: "+91 93118 15239",
      email: "contact@weddingzvenue.in",
      address: "New Delhi, India",
    },
    socialLinks: {
      facebook: "https://www.facebook.com/share/17T53mrpff/",
      instagram:
        "https://www.instagram.com/officialweddingzvenue.in?igsh=MWppaHRxNXpkaGVydA==",
      twitter: "https://x.com/weddingzvenue",
      youtube: "https://youtube.com/@officialweddingzvenue?si=qYiVfRUZWuk1yAyw",
      pinterest: "https://pin.it/2E12UTntS",
      linkedin: "https://www.linkedin.com/services/page/b692963417b156a2a3",
      telegram: "https://t.me/OfficialWeddingzvenue",
      whatsapp: "https://wa.me/919311815239",
    },
    // Profile cards above footer. Set image to a URL or path (e.g. "/images/social/instagram.jpg").
    // Social platforms don't allow frontend fetch of profile images; use your own image URLs or leave null for placeholder.
    socialProfileCards: [
      {
        platform: "Instagram",
        handle: "officialweddingzvenue.in",
        url: "https://www.instagram.com/officialweddingzvenue.in?igsh=MWppaHRxNXpkaGVydA==",
        buttonText: "Follow",
        overlayLabel: "Followers",
        image: "/images/social/instagram-card.png",
      },
      {
        platform: "Facebook",
        handle: "WeddingzVenue",
        url: "https://www.facebook.com/share/17T53mrpff/",
        buttonText: "Follow",
        overlayLabel: "Like",
        image: "/images/social/facebook-logo.png",
      },
      {
        platform: "Pinterest",
        handle: "WeddingzIndia",
        url: "https://pin.it/2E12UTntS",
        buttonText: "Follow",
        overlayLabel: "Pins",
        image: "/images/social/pinterest-card.png",
      },
      {
        platform: "YouTube",
        handle: "officialweddingzvenue",
        url: "https://youtube.com/@officialweddingzvenue?si=qYiVfRUZWuk1yAyw",
        buttonText: "Subscribe",
        overlayLabel: "Subscribers",
        image: "/images/social/youtube-card.png",
      },
    ],
    copyright: (year) => `© ${year} WeddingzVenue. All rights reserved.`,
    bottomLinks: [
      { label: "Privacy", path: "/privacy-policy" },
      { label: "Terms", path: "/terms" },
      { label: "Cookies", path: "/cookies" },
    ],
  },

  // Admin Panel
  admin: {
    logoText: "WeddingzVenue Admin",
    logoIcon: "WV",
    menuItems: [
      { path: "/admin/dashboard", label: "Dashboard", icon: "📊" },
      { path: "/admin/business-users", label: "Business Users", icon: "🏪" },
      { path: "/admin/users", label: "Manage Users", icon: "🏢" },
      { path: "/admin/create-user", label: "Create User", icon: "👤" },
      {
        path: "/admin/create-business-user",
        label: "Create Business User",
        icon: "🏪",
      },
      { path: "/admin/enquiries-users", label: "Manage Enquiries", icon: "👔" },
      { path: "/admin/real-weddings", label: "Real Weddings", icon: "💒" },
      { path: "/admin/blogs", label: "Blogs", icon: "📝" },
      // { path: "/admin/users", label: "Manage Users", icon: "👥" },
      // { path: "/admin/bookings", label: "Bookings", icon: "📅" },
      // { path: "/admin/content", label: "Content Management", icon: "📝" },
    ],
    logoutText: "Logout",
    helpLabel: "Help",
    profileInitials: "A",
    profileName: "Admin",
    profileEmail: "admin@weddingzvenue.com",
  },
};

// Export individual sections for easier imports
export const {
  brand,
  cities,
  header,
  hero,
  citiesSection,
  vendorCategories,
  pages,
  loginModal,
  businessLoginModal,
  registerPage,
  contactBanner,
  footer,
  admin,
  STEPS,
  BUSINESS_TYPE_OPTIONS,
  VENUE_TYPE_OPTIONS,
  VENDOR_TYPE_OPTIONS,
  VENDOR_OFFERING_TAGS,
} = APP_CONFIG;
